declare namespace $ {

	type __shm_date_view_1 = $mol_type_enforce<
		Parameters< $shm_date_view['value_changed'] >[0]
		,
		Parameters< ReturnType< $shm_date_view['Input'] >['value_changed'] >[0]
	>
	type $mol_button_minor__hint_shm_date_view_2 = $mol_type_enforce<
		ReturnType< $shm_date_view['prev_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_shm_date_view_3 = $mol_type_enforce<
		ReturnType< $shm_date_view['prev_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_date_view_4 = $mol_type_enforce<
		ReturnType< $shm_date_view['prev'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_date_view_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_shm_date_view_6 = $mol_type_enforce<
		ReturnType< $shm_date_view['next_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_shm_date_view_7 = $mol_type_enforce<
		ReturnType< $shm_date_view['next_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_date_view_8 = $mol_type_enforce<
		ReturnType< $shm_date_view['next'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_date_view_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_shm_date_view_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_date_input__value_shm_date_view_11 = $mol_type_enforce<
		ReturnType< $shm_date_view['input_value'] >
		,
		ReturnType< $shm_date_input['value'] >
	>
	type $shm_date_input__submit_shm_date_view_12 = $mol_type_enforce<
		ReturnType< $shm_date_view['input_commit'] >
		,
		ReturnType< $shm_date_input['submit'] >
	>
	type $shm_date_input__mask_shm_date_view_13 = $mol_type_enforce<
		ReturnType< $shm_date_view['input_mask'] >
		,
		ReturnType< $shm_date_input['mask'] >
	>
	type $shm_date_input__enabled_shm_date_view_14 = $mol_type_enforce<
		ReturnType< $shm_date_view['enabled'] >
		,
		ReturnType< $shm_date_input['enabled'] >
	>
	type $shm_date_input__event_shm_date_view_15 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_date_view['input_commit'] > ): ReturnType< $shm_date_view['input_commit'] >,
		})  & ReturnType< $shm_date_input['event'] >
		,
		ReturnType< $shm_date_input['event'] >
	>
	type $shm_date_calendar__enabled_shm_date_view_16 = $mol_type_enforce<
		ReturnType< $shm_date_view['enabled'] >
		,
		ReturnType< $shm_date_calendar['enabled'] >
	>
	type $shm_date_calendar__month_moment_shm_date_view_17 = $mol_type_enforce<
		ReturnType< $shm_date_view['month_moment'] >
		,
		ReturnType< $shm_date_calendar['month_moment'] >
	>
	type $shm_date_calendar__day_selected_shm_date_view_18 = $mol_type_enforce<
		ReturnType< $shm_date_view['day_selected'] >
		,
		ReturnType< $shm_date_calendar['day_selected'] >
	>
	type $shm_date_calendar__day_theme_shm_date_view_19 = $mol_type_enforce<
		ReturnType< $shm_date_view['day_theme'] >
		,
		ReturnType< $shm_date_calendar['day_theme'] >
	>
	type $shm_date_calendar__day_enabled_shm_date_view_20 = $mol_type_enforce<
		ReturnType< $shm_date_view['day_enabled'] >
		,
		ReturnType< $shm_date_calendar['day_enabled'] >
	>
	type $shm_date_calendar__day_click_shm_date_view_21 = $mol_type_enforce<
		ReturnType< $shm_date_view['day_click'] >
		,
		ReturnType< $shm_date_calendar['day_click'] >
	>
	type $shm_date_calendar__head_shm_date_view_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_date_calendar['head'] >
	>
	export class $shm_date_view extends $mol_date {
		input_value( next?: string ): string
		value_changed( next?: ReturnType< ReturnType< $shm_date_view['Input'] >['value_changed'] > ): ReturnType< ReturnType< $shm_date_view['Input'] >['value_changed'] >
		input_commit( next?: any ): any
		input_mask( id: any): string
		enabled( ): boolean
		month_moment( ): ReturnType< $shm_date_view['value_moment'] >
		day_selected( id: any): boolean
		day_theme( id: any): any
		day_enabled( id: any): boolean
		day_click( id: any, next?: any ): any
		Calendar_title( ): ReturnType< ReturnType< $shm_date_view['Calendar'] >['Title'] >
		prev_hint( ): string
		prev_enabled( ): boolean
		prev( next?: any ): any
		Prev_icon( ): $mol_icon_chevron_left
		Prev( ): $mol_button_minor
		next_hint( ): string
		next_enabled( ): boolean
		next( next?: any ): any
		Next_icon( ): $mol_icon_chevron_right
		Next( ): $mol_button_minor
		Calendar_tools( ): $mol_view
		value_min( ): string
		value_max( ): string
		Input( ): $shm_date_input
		Calendar( ): $shm_date_calendar
	}
	
	export class $shm_date_input extends $mol_format {
	}
	
	type $mol_button_minor__title_shm_date_calendar_1 = $mol_type_enforce<
		ReturnType< $shm_date_calendar['day_text'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__attr_shm_date_calendar_2 = $mol_type_enforce<
		({ 
			'mol_theme': ReturnType< $shm_date_calendar['day_theme'] >,
			'shm_date_selected': ReturnType< $shm_date_calendar['day_selected'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__event_click_shm_date_calendar_3 = $mol_type_enforce<
		ReturnType< $shm_date_calendar['day_click'] >
		,
		ReturnType< $mol_button_minor['event_click'] >
	>
	type $mol_button_minor__minimal_height_shm_date_calendar_4 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_button_minor['minimal_height'] >
	>
	type $mol_button_minor__enabled_shm_date_calendar_5 = $mol_type_enforce<
		ReturnType< $shm_date_calendar['day_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	export class $shm_date_calendar extends $mol_date_calendar {
		day_theme( id: any): any
		day_selected( id: any): boolean
		day_click( id: any, next?: any ): any
		day_enabled( id: any): boolean
		Day_button( id: any): $mol_button_minor
		day_content( id: any): readonly(any)[]
	}
	
}

//# sourceMappingURL=date.view.tree.d.ts.map